import React, { Fragment, useState } from 'react'
import timeHumanize from "../../../helpers/timeHumanize"
import { Tooltip } from 'reactstrap'

const TableRow = (props) => {
    const { request } = props
    const [tooltipOpen, setTooltipOpen] = useState(false)
    const [tooltipOpenF, setTooltipOpenF] = useState(false)


    const toggle = () => {
        setTooltipOpen(!tooltipOpen)
    }

    const toggleF = () => {
        setTooltipOpenF(!tooltipOpenF)
    }

    const _mapStatus = (status) => {
        if (!status) {
            return null
        }

        let output = ""
        switch (status) {
            case "partial":
                output = <span className="badge badge-info">{status}</span>
                break
            case "rejected":
            case "cancelled":
            case "failed":
                output = <span className="badge badge-danger">{status}</span>
                break
            case "fulfilled":
            case "created":
                output = <span className="badge badge-success">{status}</span>
                break
            case "unfulfilled":
                output = <span className="badge badge-warning">{status}</span>
                break
            case "pending":
                output = <span className="badge badge-info pending-animation">{status}</span>
                break
            case "processing":
            case "in_production":
                output = <span className="badge badge-primary processing-animation">{status}</span>
                break
            case "processed":
            case "shipped":
                output = <span className="badge badge-primary">{status}</span>
                break
            case "paid":
            case "archived":
                output = <span className="badge badge-secondary">{status}</span>
                break
            default:
                output = <span className="badge badge-secondary">{status}</span>
        }

        return output
    }

    const _mapStatus3D = (status) => {
        if (!status) {
            return null
        }

        let output = ""
        switch (status) {
            case "unprinted":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Chưa in</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Chưa in
                        </Tooltip>
                    </Fragment>
                break
            case "pushed":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Đã đẩy</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Đã đẩy
                        </Tooltip>
                    </Fragment>

                break
            case "printed":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Đã in</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Đã in
                        </Tooltip>
                    </Fragment>
                break
            case "transferred":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Đã ép</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Đã ép
                        </Tooltip>
                    </Fragment>
                break
            case "confirmed":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>QC sau ép</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            QC sau ép
                        </Tooltip>
                    </Fragment>
                break
            case "sewing":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Đang may</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Đang may
                        </Tooltip>
                    </Fragment>
                break
            case "completed":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Hoàn thành</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Hoàn thành
                        </Tooltip>
                    </Fragment>
                break
            case "shipped":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Đã ship</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Đã ship
                        </Tooltip>
                    </Fragment>
                break
            case "cancel-ship":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>Hủy ship</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpen}
                            toggle={toggle}
                            delay={false}
                        >
                            Hủy ship
                        </Tooltip>
                    </Fragment>
                break
            default:
                return
        }

        return output
    }

    const _mapStatusFAC = (status) => {
        if (!status) {
            return null
        }

        let output = ""
        switch (status) {
            case "partial":
                output =
                    <Fragment>
                        <span className="badge badge-info" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            case "rejected":
            case "cancelled":
            case "failed":
                output =
                    <Fragment>
                        <span className="badge badge-danger" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            case "fulfilled":
            case "created":
                output =
                    <Fragment>
                        <span className="badge badge-success" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            case "unfulfilled":
                output =
                    <Fragment>
                        <span className="badge badge-warning" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            case "pending":
                output =
                    <Fragment>
                        <span className="badge badge-info pending-animation" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            case "processing":
            case "in_production":
                output =
                    <Fragment>
                        <span className="badge badge-primary processing-animation" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            case "processed":
            case "shipped":
                output =
                    <Fragment>
                        <span className="badge badge-primary" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            case "paid":
            case "archived":
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
                break
            default:
                output =
                    <Fragment>
                        <span className="badge badge-secondary" id={`${status}-tooltip-${request._id}`}>{status}</span>
                        <Tooltip
                            placement="top"
                            target={`${status}-tooltip-${request._id}`}
                            isOpen={tooltipOpenF}
                            toggle={toggleF}
                            delay={false}
                        >
                            {status}
                        </Tooltip>
                    </Fragment>
        }

        return output
    }

    return (
        <tr className="TableRow">
            <td>{request.fac_barcode_number || ''}</td>
            <td>{request.fac_sku || ''}</td>
            <td>{timeHumanize(request.created_at)}</td>
            <td>{timeHumanize(request.updated_at)}</td>
            <td className="ProgressStatus">
                <div className={request.progress_status}>
                    {request.progress_status}
                </div>
            </td>
            <td>
                <div className={`ForceUpdate ${request.force_update && 'Yes'}`}>
                    {request.force_update ? 'Yes' : 'No'}
                </div>
            </td>
            <td className="Source">{request.source}</td>
            <td>{_mapStatus(request.production_status)}</td>
            <td>{_mapStatusFAC(request.current_production_status)}</td>
            <td>{_mapStatus3D(request.current_production_status_3d)}</td>
        </tr>
    )
}

export default TableRow
